import React from 'react'
import Building from './Building/Building'
import Employee from './Employee/Employee'
import Equipment from './Equipment/Equipment'

import styled from 'styled-components'

const DetailContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  box-shadow: -3px 0 35px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 1023px) {
    flex-direction: row;
  }
`

const Detail = props => {
  const {detailId, options, onExpand} = props

  const DETAIL_CONTENT = {
    createrequest: {
      content: <div />,
      searchResult: false
    },
    em: {content: <Employee emId={options.emId} />},
    bl: {content: <Building options={options} onExpand={onExpand}/>},
    rm: {content: <Building options={options} onExpand={onExpand}/>},
    eq: {content: <Equipment eqId={options.eqId} />},
    none: {content: <div />},
    dbem: {content: <Employee />}
  }

  const {content} = DETAIL_CONTENT[detailId] || DETAIL_CONTENT['em']

  return (
    <DetailContainer id={'detail'}>
      <div>{content}</div>
    </DetailContainer>
  )
}

export default Detail
